import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { canAccessFeature } from "../../auth/featureScopes";
import { useAuth } from "../../contexts/AuthContext";

/**
 * The eBay listing editor now lives in the "Listing" tab of the stock page.
 * The old listing routes (/ebay-listings/:partId, /ebay-unlisted/:partId,
 * /recently-listed/:partId) redirect here so existing links keep working.
 *
 * Without the Order Management feature there is no Listing tab, so those users
 * are dropped on the stock page instead of a tab they can't see.
 */
export default function ListingRedirect() {
  const { partId } = useParams();
  const [searchParams] = useSearchParams();
  const { featureScopes } = useAuth();

  if (!partId) {
    return <Navigate to="/stock" replace />;
  }

  const params = new URLSearchParams(searchParams);

  if (canAccessFeature(featureScopes, "orderManagement")) {
    params.set("tab", "listing");
  } else {
    params.delete("tab");
  }

  const query = params.toString();

  return <Navigate to={`/stock/${partId}${query ? `?${query}` : ""}`} replace />;
}
